import axios from 'axios';

// ============================================================
// 跃创 API 配置
// 真实对接时替换 BASE_URL 和 AppKey/AppSecret
// ============================================================
const YUE_BASE_URL = process.env.REACT_APP_YUE_API_URL || 'https://api.yuechuang.com/v1';
const YUE_APP_KEY  = process.env.REACT_APP_YUE_APP_KEY  || 'YOUR_APP_KEY';
const YUE_SECRET   = process.env.REACT_APP_YUE_SECRET   || 'YOUR_APP_SECRET';

// -------- axios 实例 --------
export const yueApi = axios.create({
  baseURL: YUE_BASE_URL,
  timeout: 10000,
});

// 请求拦截：注入签名
yueApi.interceptors.request.use((config) => {
  const timestamp = Date.now().toString();
  if (config.headers) {
    config.headers['X-App-Key']   = YUE_APP_KEY;
    config.headers['X-Timestamp'] = timestamp;
    config.headers['X-Sign']      = `${YUE_APP_KEY}${timestamp}${YUE_SECRET}`;
  }
  return config;
});

// ============================================================
// 跃创 API 接口封装
// ============================================================

/** 查询卡列表 */
export const getCardList = (params: {
  page?: number;
  pageSize?: number;
  status?: string;
  iccid?: string;
}) => yueApi.get('/cards', { params });

/** 查询单卡详情 */
export const getCardDetail = (iccid: string) =>
  yueApi.get(`/cards/${iccid}`);

/** 查询卡流量 */
export const getCardTraffic = (iccid: string) =>
  yueApi.get(`/cards/${iccid}/traffic`);

/** 激活卡 */
export const activateCard = (iccid: string) =>
  yueApi.post(`/cards/${iccid}/activate`);

/** 停机 */
export const stopCard = (iccid: string) =>
  yueApi.post(`/cards/${iccid}/stop`);

/** 复机 */
export const resumeCard = (iccid: string) =>
  yueApi.post(`/cards/${iccid}/resume`);

/** 批量操作 */
export const batchOperate = (iccids: string[], action: 'stop' | 'resume' | 'activate') =>
  yueApi.post('/cards/batch', { iccids, action });

/** 变更套餐 */
export const changePackage = (iccid: string, packageId: string) =>
  yueApi.post(`/cards/${iccid}/package`, { packageId });

/** 查询套餐列表 */
export const getPackages = () =>
  yueApi.get('/packages');

/** 查询定位 */
export const getLocation = (iccid: string) =>
  yueApi.get(`/cards/${iccid}/location`);

/** 查询历史轨迹 */
export const getTrail = (iccid: string, startTime: string, endTime: string) =>
  yueApi.get(`/cards/${iccid}/trail`, { params: { startTime, endTime } });

// ============================================================
// 模拟数据兜底（API未配置或调用失败时使用）
// ============================================================
export const MOCK_CARDS = Array.from({ length: 50 }, (_, i) => ({
  iccid: `89860319210100734${String(i + 1).padStart(2, '0')}`,
  msisdn: `1381234${String(5678 + i).padStart(4, '0')}`,
  imsi: `46000191000${String(i + 1).padStart(5, '0')}`,
  operator: ['cmcc', 'cucc', 'ctcc', 'global'][i % 4],
  status: ['active', 'offline', 'stop', 'testing', 'cancel'][i % 5],
  package: ['月包10GB', '月包20GB', '年包50GB', '全球套餐5GB'][i % 4],
  usedMB: Math.floor(Math.random() * 10000),
  totalMB: [10240, 20480, 51200, 5120][i % 4],
  client: ['深圳割草机科技', '广州CPE公司', '北京VR体验', '上海安防'][i % 4],
  expireDate: `2026-${String((i % 12) + 1).padStart(2, '0')}-01`,
  activateDate: `2025-${String((i % 12) + 1).padStart(2, '0')}-01`,
  tags: i % 3 === 0 ? ['割草机', '华南'] : i % 3 === 1 ? ['CPE', '华东'] : ['VR', '海外'],
}));
